<template>
  <footer class="main-footer">
    <div class="container">
      <div class="pull-right hidden-xs">
        <b>School of Public Health</b>
      </div>
      <strong>Copyright &copy; 2024.</strong> All rights reserved.
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>
<style>
    .main-footer{
        background: #bf9f62;
        color:white;
    }
</style>

